import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

const ServerError: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <SEO
        title={t('serverError.title')}
        description={t('serverError.description')}
      />
      <Container maxWidth="md">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '80vh',
            textAlign: 'center',
            py: 8,
          }}
        >
          <Typography
            variant="h1"
            component="h1"
            sx={{
              fontSize: { xs: '6rem', sm: '8rem' },
              fontWeight: 'bold',
              color: 'error.main',
              mb: 2,
            }}
          >
            500
          </Typography>
          <Typography
            variant="h2"
            component="h2"
            sx={{
              fontSize: { xs: '1.5rem', sm: '2rem' },
              fontWeight: 'medium',
              mb: 2,
            }}
          >
            {t('serverError.title')}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: '1rem', sm: '1.25rem' },
              color: 'text.secondary',
              mb: 4,
              maxWidth: '600px',
            }}
          >
            {t('serverError.description')}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={() => navigate('/')}
            sx={{
              px: 4,
              py: 1.5,
              fontSize: '1.1rem',
            }}
          >
            {t('serverError.backToHome')}
          </Button>
        </Box>
      </Container>
    </>
  );
};

export default ServerError; 